import styled from "styled-components";

import locationBg from "../../assets/img/locationBg.png";

// ── Shared checkout / shipping page chrome ──────────────────────────────────
// One source of truth for the checkout background page (`Container`) and the
// white content card (`Wrapper`). Every shipping screen imports these instead
// of declaring its own, so layout fixes happen ONCE here rather than being
// re-patched per screen (which had drifted into inconsistent copies).
//
// Why the top padding: each vertical's navbar (RetailerWholesaler / Restaurant
// / Healthcare / in-house) is `position: fixed; top: 0`, so it sits above the
// page flow. The page pads its top by the navbar height so content is never
// hidden underneath it. `align-items: flex-start` (not center) keeps a tall
// card's top from being pushed back up under the navbar.

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    url(${locationBg}) center;
  background-size: cover;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: var(--lusuku-nav-h, 130px);
  padding-bottom: 30px;

  @media (max-width: 850px) {
    /* Navbars stack into two rows below 850px, so they are taller. */
    padding-top: 175px;
  }
`;

export const Wrapper = styled.div`
  width: 50%;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.9);
  box-sizing: border-box;
  overflow-x: hidden;

  @media (max-width: 768px) {
    width: 87%;
    padding: 10px;
  }
`;
